import { DropdownModel } from '@shared/models/dropdown-model.model';
import { Expose, Type } from 'class-transformer';
import { Media } from '../../shared-features/models/media.model';
import { ProductType } from '../../shipments/models/product-type.model';
import { LocationModel } from './location.model';
import { CustomerEtaConfiguration, CustomerServiceType } from '../../shared-features/enums/shared-enums.enum';
import { Receiver } from '../../receivers/models/receiver.model';
import { ShipmentCreationTemplate } from '../../shipments/models/shipment-template.model';
import { User } from '../../users/models/user.model';
import { UserInvoiceType } from '@shared-features/enums/user-invoice-type.enum';
import { PricingMethod } from '@shared-features/enums/pricing-method';
import { VendorSource } from '@shared-features/enums/vendor-source.enum';

export class Customer extends DropdownModel {
  @Expose() id?: number;
  @Expose() uuid?: string;
  @Expose() title = '';
  @Expose() contactFirstName = '';
  @Expose() contactLastName = '';
  @Expose() email: string;
  @Expose() shipmentsCount?: number;
  @Expose() mobileNumber: string;
  @Expose() contactMobileNumber? = '';
  @Expose() code?: string;
  @Expose() commercialRegistration?: Media = new Media();
  @Expose() logo?: Media = new Media();
  @Expose() primaryTheme?: string;
  @Expose() usersCount?: number;
  @Expose() status?: string;
  @Expose() vatNumber?: string;
  @Expose() crNumber: number;
  @Expose() activationDate?: number;
  @Expose() createdAt?: number;
  @Expose() updatedAt?: number;
  @Expose() productTypes?: ProductType[] = [];
  @Type(() => LocationModel)
  @Expose()
  locations?: LocationModel[] = [];
  @Expose() canAssignDrivers?: boolean;
  @Expose() dueDays?: number;
  @Expose() waitingChargePerDay?: number;
  @Expose() showAllTruckType?: boolean;
  @Expose() rejectReason?: string;
  @Expose() verifyShipmentsByReceivers?: boolean;
  @Expose() etaConfiguration?: CustomerEtaConfiguration;
  @Expose() localVatPercentage?: number;
  @Expose() exportVatPercentage?: number;
  @Expose() sisterCompanyVatPercentage?: number;
  @Expose() sisterCompanies?: Receiver[] = [];
  @Expose() contactType?: string;
  @Expose() isDefault?: boolean;
  @Expose() customerCommercialNameEn: string;
  @Expose() customerCommercialNameAr: string;
  @Expose() address: string;
  @Expose() addressAr: string;
  @Expose() customerForLocation?: boolean;
  @Expose() parentId?: number;
  @Expose() commercialRegistrationId?: number;
  @Expose() customerType?: CustomerServiceType;
  @Expose() parent?: any;
  @Type(() => LocationModel)
  @Expose()
  childrenLocations?: LocationModel[] = [];
  @Expose() canCreateShipmentWithoutPriceAndCost?: boolean;
  @Expose()
  createdByCustomer?: number;
  @Expose()
  creationTemplates?: ShipmentCreationTemplate[];
  allLocations?: LocationModel[] = [];
  @Expose()
  accessToken?: string;
  @Expose()
  refreshToken?: string;
  @Type(() => User)
  @Expose()
  users?: User[];
  @Expose()
  isFromOnlineBooking?: boolean;

  @Expose()
  allowToSelectAllDriversAndTrucks?: boolean;

  @Expose()
  allowToCancelShipment?: boolean;

  @Expose()
  reference?: string;

  @Expose()
  isWalletEnabled?: boolean;

  @Expose()
  pricingMethod?: PricingMethod;

  @Expose() customerInvoiceType?: UserInvoiceType;

  @Expose()
  vendorSource?: VendorSource;

  constructor() {
    super();
  }

  get contactName(): string {
    return this.contactFirstName + ' ' + this.contactLastName;
  }

  get dropDownDisplayName(): string {
    return this.title;
  }
  get dropDownValue(): Object {
    return this;
  }
}
